export default __webpack_public_path__ + "static/media/logo.909ae06c.png";